import { useApp } from "@/context/AppProviders";
import { cn, SITE_LOGO_DARK_SRC, SITE_LOGO_SRC } from "@/lib/utils";

type EnabaseLogoProps = {
  className?: string;
  /** Footer gibi her zaman koyu arka planlı alanlar için `dark` kullanın. */
  variant?: "theme" | "dark" | "light";
};

export function EnabaseLogo({
  className,
  variant = "theme",
}: EnabaseLogoProps) {
  const { isDark } = useApp();
  const useDarkLogo =
    variant === "dark" || (variant === "theme" && isDark);

  return (
    <img
      src={useDarkLogo ? SITE_LOGO_DARK_SRC : SITE_LOGO_SRC}
      alt="Enabase"
      className={cn("object-contain object-left", className)}
      width={184}
      height={44}
      decoding="async"
      fetchPriority="low"
    />
  );
}
